type SeoOptions = {
  title: string;
  description: string;
  canonical?: string;
  robots?: string;
};

function setMetaByName(name: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

function setMetaByProperty(property: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

export function applySeo({
  title,
  description,
  canonical,
  robots = "index,follow",
}: SeoOptions) {
  document.title = title;

  setMetaByName("description", description);
  setMetaByName("robots", robots);

  let canonicalLink = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (canonical) {
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);
  } else {
    canonicalLink?.remove();
  }

  setMetaByProperty("og:title", title);
  setMetaByProperty("og:description", description);

  let ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
  if (canonical) {
    if (!ogUrl) {
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute("content", canonical);
  } else {
    ogUrl?.remove();
  }

  setMetaByName("twitter:title", title);
  setMetaByName("twitter:description", description);
}
